import { FrequentlyAskedQuestionsIcon } from './FrequentlyAskedQuestionsIcon';

/**
 * author: Austin Andrews
 * id A53E5953-2094-419A-A418-57BE05F751C8
 * name frequently-asked-questions
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/frequently-asked-questions.svg
 * tags
 */
export const FaqIcon = FrequentlyAskedQuestionsIcon;
export default FaqIcon